@if (open) {
<div class="home-cancelar-modal" role="dialog" aria-modal="true"
  [attr.aria-labelledby]="step === 'form' ? 'home-cancelar-title' : 'home-cancelar-confirm-title'"
  (click)="onBackdrop($event)">
  <div class="home-cancelar-modal__panel" (click)="$event.stopPropagation()">
    @if (step === 'form') {
    <header class="home-cancelar-modal__header">
      <span class="home-cancelar-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="home-cancelar-modal__title" id="home-cancelar-title">
        {{ copy.titulo }}
      </h2>
      <button type="button" class="home-cancelar-modal__close" aria-label="Cerrar" (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="home-cancelar-modal__body home-cancelar-modal__body--form">
      <div class="home-cancelar-modal__solicitud">
        <span class="home-cancelar-modal__solicitud-label">{{ copy.numeroLabel }}</span>
        <strong class="home-cancelar-modal__solicitud-value">{{ idSolicitud }}</strong>
      </div>

      <div class="home-cancelar-modal__field"
        [class.home-cancelar-modal__field--invalid]="showObservacionError">
        <label class="home-cancelar-modal__label" for="home-cancelar-observacion">
          {{ copy.observacionLabel }}
        </label>
        <textarea id="home-cancelar-observacion" class="home-cancelar-modal__textarea" name="observacionNegacion"
          rows="4" maxlength="3000" [(ngModel)]="observacion"
          [class.home-cancelar-modal__textarea--invalid]="showObservacionError"
          [attr.aria-invalid]="showObservacionError"></textarea>
        @if (showObservacionError) {
        <p class="home-cancelar-modal__error">{{ copy.observacionError }}</p>
        }
      </div>

      <div class="home-cancelar-modal__actions">
        <button type="button" class="home-cancelar-modal__btn home-cancelar-modal__btn--secondary"
          id="btn-home-cancelar-salir" (click)="onSalirForm()">
          {{ copy.ctaSalir }}
        </button>
        <button type="button" class="home-cancelar-modal__btn home-cancelar-modal__btn--primary"
          id="btn-home-cancelar-solicitud" [disabled]="observacionInvalida" (click)="onCancelarSolicitud()">
          {{ copy.ctaCancelar }}
        </button>
      </div>
    </div>
    } @else {
    <header class="home-cancelar-modal__header">
      <span class="home-cancelar-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="home-cancelar-modal__title" id="home-cancelar-confirm-title">
        {{ copy.tituloConfirm }}
      </h2>
      <button type="button" class="home-cancelar-modal__close" aria-label="Cerrar" [disabled]="confirmando"
        (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="home-cancelar-modal__body">
      @if (mensajeConfirmacion) {
      <p class="home-cancelar-modal__text">{{ mensajeConfirmacion }}</p>
      }

      <div class="home-cancelar-modal__actions">
        <button type="button" class="home-cancelar-modal__btn home-cancelar-modal__btn--secondary"
          id="btn-home-cancelar-confirm-salir" [disabled]="confirmando" (click)="onSalirConfirm()">
          {{ copy.ctaSalir }}
        </button>
        <button type="button" class="home-cancelar-modal__btn home-cancelar-modal__btn--primary"
          id="btn-home-cancelar-confirmar" [disabled]="confirmando" (click)="onConfirmar()">
          {{ confirmando ? copy.ctaConfirmando : copy.ctaConfirmar }}
        </button>
      </div>
    </div>
    }
  </div>
</div>
}
